import {useNavigate} from "react-router-dom";
import {truchateString} from "../../../../utils/utils";

export function BlogCardAnimation({className, ...props}) {
    return (
        <div className={`animate-pulse ${className} p-[0.75rem]`}>
            <div className={"w-full h-[200px] mb-2 rounded-md bg-gray-200"}></div>
            <div className={"flex flex-col gap-1  "}>
                <div className={"w-3/4 h-4 bg-gray-200"}></div>
                <div className={"w-1/2 h-4 bg-gray-200"}></div>
                <div className={"w-1/3 h-4 bg-gray-200"}></div>
            </div>
        </div>
    )
}

export default function BlogCard({
                                     className,
                                     title,
                                     refreshCallBack,
                                     metaDescription,
                                     date,
                                     thumbnail,
                                     variant,
                                     ...props
                                 }) {
    let image = thumbnail
    let style = variant && variant === "card" ? "rounded-md bg-white shadow-sm p-[0.75rem]" : "";
    const navigate = useNavigate();
    return (
        <div className={` ${className} ${style} gap-2 flex flex-col`}>
            <img
                src={image}
                alt={"blog"}
                className={"w-full h-[200px] object-cover "}
            />

            <div className={"flex flex-col gap-1  "}>
                <p className={"font-semibold text-xs text-secondary-900"}>
                    {date}
                </p>
                <p className={"font-bold"}>
                    {title}
                </p>
                <p className={"text-sm"}>
                    {truchateString(metaDescription, 100)}
                </p>

                <div
                    onClick={() => {
                        navigate("/blogs/" + title)

                    }}
                    className={"cursor-pointer text-secondary-900 font-semibold"}>
                    Read More
                </div>

            </div>
        </div>

    )
}